module.exports = __webpack_public_path__ + "static/media/section2.ff309ba6.png";